export default __webpack_public_path__ + "static/media/water-label.42c4abea.png";